import {
  sendAmplitudeEvent,
  byWindowAction,
  byUserInteraction,
  sendRequest,
} from '@html/_common/utils';

import AOTourRateTranslation from '@atomic/organisms/_common/rate-translation';

export default class AOThreadedFaqs {
  constructor(tourId, mobileWidth, tdpEventCategory) {
    this.tourId = tourId;

    this.page = 1;
    this.onpage = parseInt($('.js-ao-tour-faq').attr('data-onpage'), 10);
    this.searchPhrase = '';
    this.typeId = null;
    this.buttons = false;
    this.TDP_EVENT_CATEGORY = tdpEventCategory;
    this.QUESTIONS_INITIALLY_VISIBLE = 5;
  }

  initiate() {
    this.showButtons();

    this.initializeVotes();

    byUserInteraction('tour-load-tags', this.loadTags.bind(this));

    $('.js-ao-tour-load-more__button').click(() => {
      sendAmplitudeEvent({
        ampEventName: 'tdp_show_more_faqs_clicked',
      });

      this.page += 1;

      /* check first if we can display questions on page */
      let done = false;
      $('.js-ao-tour-threaded-faq').forEach((elem) => {
        if ($(elem).hasClass('hid')) {
          $(elem).removeClass('hid');
          done = true;
        }
      });
      if (!done) {
        this.loadQuestions();
      }
    });

    this.initializeTranslations();

    this.loadAnswers();

    this.initializeShowHiddenAnswers();

    this.hideQuestions(this.QUESTIONS_INITIALLY_VISIBLE);
  }

  initializeTranslations() {
    const $container = $('.js-ao-tour-faq');
    const rateTranslation = new AOTourRateTranslation(null, $container);
    rateTranslation.initiate();
    $container.find('.translate-link').click((event) => {
      const link = $(event.currentTarget);
      if (link.parent('.translated-block').hasClass('original')) {
        $container.find('.translated-block.translated').removeClass('hid');
        $container.find('.translated-block.original').addClass('hid');
      } else {
        $container.find('.translated-block.translated').addClass('hid');
        $container.find('.translated-block.original').removeClass('hid');
      }
      this.page = 1;
      this.loadQuestions();
    });
  }

  // eslint-disable-next-line class-methods-use-this
  loadTags() {
    sendRequest(
      '/api/faq/question-types',
      { tour_id: this.tourId },
      (data) => {
        if (data && data.status === 'OK' && data.types && Object.keys(data.types)?.length > 0) {
          Object.keys(data.types).forEach((key) => {
            $('.js-ao-tour-faq__tags').append(`<div class="ao-tour-faq__tags-item js-ao-tour-faq__tags-item js-ao-tour-faq__tags-item-dynamic" data-tag-id="${key}">${data.types[key]}</div>`);
          });
          $('.js-ao-tour-faq__tags').removeClass('hid');
          $('.js-ao-tour-faq__tags-item').forEach((elem) => {
            $(elem).on('click', (event) => {
              this.handleTagClick($(event.currentTarget));
            });
          });
        }
      },
    );
  }

  // eslint-disable-next-line class-methods-use-this
  handleTagClick(clickedTag) {
    const tagId = clickedTag.attr('data-tag-id');

    if (clickedTag.hasClass('ao-tour-faq__tags-item--selected')) {
      return;
    }

    $('.ao-tour-faq__tags-item--selected').removeClass('ao-tour-faq__tags-item--selected');
    clickedTag.addClass('ao-tour-faq__tags-item--selected');

    if (tagId === 'all') {
      this.typeId = null;
    } else {
      this.typeId = tagId;
    }
    this.searchPhrase = null;
    $('.js-ao-tour-faq__search-form-input').val('');
    this.page = 1;
    this.loadQuestions();

    sendAmplitudeEvent({
      ampEventName: 'tdp_faq_category_clicked',
      tdp_faq_category: clickedTag.text(),
    });
  }

  loadAnswers() {
    const $answersToLoad = $('.js-ao-tour-faq--load-answers');

    if (!$answersToLoad.length) {
      return;
    }

    byUserInteraction('tour-load-answers', () => {
      const ids = [];
      $answersToLoad.each((index, element) => {
        ids.push($(element).data('question-id'));
      });

      if (!ids.length) {
        return;
      }

      sendRequest('/api/faq/load-answers', {
        ids,
        tourId: this.tourId,
      }, (data) => {
        if (data && data.status === 'OK') {
          Object.keys(data.answers).map((id) => $(`.js-ao-tour-faq--load-answers[data-question-id="${id}"] .js-ans`).html(data.answers[id]));
        }
      });
    });
  }

  showButtons() {
    if ($('.js-ao-tour-faq').length > 0) {
      byWindowAction(['scroll'], () => {
        const $window = $(window);
        if (!this.buttons && ($window.scrollTop() + $window.height()) >= $('.js-ao-tour-faq').offset().top) {
          this.buttons = true;
          const ids = [];
          $('.ao-tour-threaded-faq__answer').each((index, element) => {
            ids.push($(element).attr('data-id'));
          });

          if (ids.length > 0) {
            sendRequest('/api/tour/load', {
              action: 'answer_buttons',
              ids,
            }, (data) => {
              if (data && data.status === 'OK') {
                Object.keys(data.component).map((id) => $(`.ao-tour-threaded-faq__answer[data-id="${id}"] .js-ao-tour-threaded-faq__answer-buttons-block`).html(data.component[id]));
              }
            });
          }
        }
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  initializeVotes() {
    $('body').on('click', '.js-ao-common-helpful-block', (e) => {
      e.preventDefault();

      sendAmplitudeEvent({
        ampEventName: 'tdp_faq_feedback_clicked',
      });

      const $clickedElement = $(e.currentTarget);
      const current = parseInt($clickedElement.attr('data-curr'), 10);
      const answerId = $clickedElement.parents('.ao-tour-threaded-faq__answer').attr('data-id');

      sendRequest('/api/faq/answer-vote', { answer_id: answerId }, (data) => {
        if (data && data.status === 'OK') {
          const newCount = current + data.vote;
          $clickedElement.attr('data-curr', newCount);
          $clickedElement.html(newCount);

          if (data.vote > 0) {
            $clickedElement.addClass('ao-tour-faq__faq-button--active');
          } else {
            $clickedElement.removeClass('ao-tour-faq__faq-button--active');
            $clickedElement.trigger('blur');
          }

          if (newCount > 0) {
            $clickedElement.removeClass('ao-tour-faq__faq-button--novote');
          } else {
            $clickedElement.addClass('ao-tour-faq__faq-button--novote');
          }
        }
      });
    });
  }

  loadQuestions() {
    const $faqBlock = $('.js-ao-tour-faq');

    if (this.page === 1) {
      $('.js-ao-tour-faq > ul').html('<div class="as-serp-filters__loader scout-loader-three-dots loading"><span class="scout-loader-three-dots__loader"></span></div>');
    }

    sendRequest('/api/faq/questions-load-more', {
      object_id: this.tourId,
      shift: (this.page - 1) * this.onpage,
      onpage: this.onpage,
      type_id: this.typeId,
      search_phrase: this.typeId ? '' : this.searchPhrase,
      original: !$faqBlock.find('.translated-block.original').hasClass('hid'),
    }, (data) => {
      $('.js-ao-tour-faq > ul .scout-loader-three-dots').remove();
      if (data && data.status === 'OK') {
        if (data.html.length) {
          $('.js-ao-tour-faq > ul').append(data.html);
        } else {
          const { noResultsTitle, noResultsSubtitle } = document.querySelector('.js-ao-tour-faq > ul').dataset;
          const askButton = $('.js-ao-tour-faq__question-list--empty-content-button').html();

          $('.js-ao-tour-faq > ul').html(`
            <li class="ao-tour-faq__question-list--empty loader">
              <img src="/images/responsive/serp/serp-no-result.svg" class="empty__img">
              <div class="ao-tour-faq__question-list--empty-content">
                <div class="ao-tour-faq__question-list--empty-content-title">${noResultsTitle}</div>
                <div class="ao-tour-faq__question-list--empty-content-subtitle">${noResultsSubtitle}</div>
                ${askButton}
              </div>
            </li>
          `);
          $('.js-ao-tour-ask-expert-cta-banner').addClass('hid');
          $('.js-ao-tour-faq__search-form').on('submit', () => $('.js-ao-tour-ask-expert-cta-banner').removeClass('hid'));
          $('.js-ao-tour-faq__question-list--empty-content-button').on('click', () => $('.js-ao-tour-ask-expert-cta-banner__button').click());
        }

        this.initializeShowHiddenAnswers();
        this.populateOperatorLogoSources();

        if (this.searchPhrase) {
          this.typeId = null;
          $('.ao-tour-faq__tags-item--selected').removeClass('ao-tour-faq__tags-item--selected');
        }

        /* remove button if we reached the latest page */
        if (this.page * this.onpage >= data.total) {
          $('.js-ao-tour-load-more').hide();
        } else {
          $('.js-ao-tour-load-more').show();
        }
      }
    });
  }

  // eslint-disable-next-line class-methods-use-this
  initializeShowHiddenAnswers() {
    $('.js-ao-tour-threaded-faq__more-answers').forEach((elem) => {
      $(elem).on('click', () => {
        $(elem).parent().find('.ao-tour-threaded-faq__answers-list-item').removeClass('hid');
        $(elem).addClass('hid');
      });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  populateOperatorLogoSources() {
    const operatorSrc = $('.js-ao-tour-faq__question-list').attr('data-operator-logo');
    $('.js-ao-tour-threaded-faq__more-answers-avatars-logo-src').attr('src', operatorSrc);
    $('.js-ao-tour-threaded-faq__answer-left-logo-src').attr('src', operatorSrc);
  }

  // eslint-disable-next-line class-methods-use-this
  hideQuestions(max) {
    byUserInteraction('hideFAQs', () => {
      $('.js-ao-tour-threaded-faq').forEach((elem, index) => {
        if (index + 1 > max) {
          $(elem).addClass('hid');
        }
      });
    });
  }
}
